/**
 * Tres Commas queue: poll tc seed.
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';

export interface SeedState {
  jobId: string | null; isRunning: boolean; dryRun: boolean; stale: boolean;
  error: string | null; finishedAt: string | null; result: unknown;
}
function assertState(state: SeedState, jobId: string | null) {
  if (!jobId || state.jobId !== jobId) throw new Error('Tres Commas pull status changed. Try syncing again.');
  if (state.dryRun) throw new Error('A Tres Commas preview is running. Wait for it to finish before syncing.');
  if (state.error || state.stale) throw new Error(state.error ?? 'The Tres Commas pull stopped responding.');
}
/** Wait for each actual import to finish before starting its dependants. */
export async function pollTcSeed(base: string, initial: SeedState): Promise<void> {
  let state = initial;
  const deadline = Date.now() + 600_000;
  while (true) {
    assertState(state, initial.jobId);
    if (!state.isRunning && state.finishedAt && state.result) return;
    if (Date.now() >= deadline) throw new Error('Tres Commas pull is still running. Check its pull page before retrying.');
    await new Promise((resolve) => setTimeout(resolve, 800));
    state = (await api.get<{ data: SeedState }>(`${base}/status`)).data.data;
  }
}
